import { isNilOrEmpty, formatLarge } from '@benzinga/utils';
import { NO_VALUE } from '../../Ticker';
import { ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';

interface CellParams {
  value?: string | number;
  data: ValueFormatterParams['data'];
  colDef: {
    field?: string;
    colId?: string;
  };
}

const getByPath = (obj: any, path: string) => {
  return path.split('.').reduce((acc, part) => {
    if (acc && typeof acc === 'object' && part in acc) {
      return acc[part];
    }
    return undefined;
  }, obj);
};

const valueIdentifier = params => {
  //for nested objects like a.b
  const fieldPath = params.colDef.field ?? params.colDef.colId ?? '';

  const nestedValue = getByPath(params.data, fieldPath);

  /*handling edge-case when property is not present in response data from BE
    eg: vol/OI col in UOA calendar data we're calculating on FE side size/open_interest
  */
  if (nestedValue === undefined && params.value !== undefined) return params.value;

  return params.value !== getByPath(params.data, fieldPath) ? getByPath(params.data, fieldPath) : params.value;
};

export const getCellValue = <T extends CellParams>(params: T) => {
  const value = valueIdentifier(params);
  if (isNilOrEmpty(value)) {
    return NO_VALUE;
  }
  if (typeof value === 'number') {
    return formatLarge(value);
  }
  if (typeof value === 'string') {
    const parsedValue = parseFloat(value);
    return isNaN(parsedValue) ? NO_VALUE : formatLarge(parsedValue);
  }
  return value;
};

export const formatCellValueOrDefault = (params: ValueFormatterParams) => {
  const value = getCellValue(params);
  return !isNilOrEmpty(value) && value !== NO_VALUE ? value : NO_VALUE;
};

export const getCellValueOrDefault = (params: ValueGetterParams) => {
  const value = valueIdentifier(params);
  return !isNilOrEmpty(value) && value !== NO_VALUE ? value : 0;
};
